<template lang="pug">
  div(:style="'min-height:'+h")
    el-main.pa-3.mx-4.mt-5
      el-row(:gutter="20")
        el-col(:span="6")
          el-card.pic-bg1(style="height:180px" :body-style="{ padding: '0px' }")
            el-row
              el-col.pt-4(:span="6")
                i.iconfont1 &#xe696;
              el-col.pt-5(:span="18")
                span.title.white--text 采购需求
                div.mt-3.body-1.white--text
                  div.mt-2 合同内需求({{count11}})
                  div.mt-2 已发布商机({{count14}})  
                  div.mt-2 全部需求({{count15}})
        el-col(:span="6")
          el-card.pic-bg2(style="height:180px" :body-style="{ padding: '0px' }")
            el-row
              el-col.pt-4(:span="6")
                i.iconfont1 &#xe601;
              el-col.pt-5(:span="18")
                span.title.white--text 采购订单
                div.mt-3.body-1.white--text
                  div.mt-2 待发货订单({{count21}})
                  div.mt-2 被驳回订单({{count24}})
                  div.mt-2 全部订单({{count25}})
        el-col(:span="6")
          el-card.pic-bg3(style="height:180px" :body-style="{ padding: '0px' }")
            el-row
              el-col.pt-4(:span="6")
                i.iconfont1 &#xe6a0;
              el-col.pt-5(:span="18")
                span.title.white--text 对账单
                div.mt-3.body-1.white--text
                  div.mt-2 待发布({{count31}})
                  div.mt-2 待开票({{count34}})
                  div.mt-2 全部对账单({{count36}})
        el-col(:span="6")
          el-card.pic-bg4(style="height:180px" :body-style="{ padding: '0px' }")
            el-row
              el-col.pt-4(:span="6")
                i.iconfont1 &#xe63c;
              el-col.pt-5(:span="18")
                span.title.white--text 发票管理
                div.mt-3.body-1.white--text
                  div.mt-2 待签收发票({{count41}})
                  div.mt-2 已签收发票({{count42}})
                  div.mt-2 全部发票({{count43}})
      el-row.mt-9(:gutter="20")
        el-col(:span="24")
          el-card(:body-style="{ padding: '20px' }" style="min-height:593px")
            el-row.mb-3(:gutter="20")
              el-col(:span="12") 
                div.title(style="line-height:2") 我的待办
              el-col.text-right(:span="12")
                el-button.subheading(type="text" @click="goto('/purchase/todo')") 全部待办
            el-alert(v-if="data.length==0" title="暂无待办数据" type="error" :closable="false")
            div(v-else v-for="(item,i) in data" :key="i")
              div.pointer(style="display:flex" @click="goDetail(item)")
                div
                  i.mr-1.iconfont.display-1(v-html="getIcon(item)")
                div(style="flex:1 1")
                  div.red--text.font-weight-bold.body-2 [{{item.type_name}}]{{item.title}}
                  div.grey--lighten3--text {{item.content}}
                div.text-right.red--text.body-2 已经超期{{item.days}}天
              el-divider(v-if="i<data.length-1")
</template>
<script>
export default {
  data() {
    return {
      h: "",
      loading: false,
      data: [],
      list: {
        bill_type: null,
        page_num: 1,
        page_size: 6,
      },
      count11: 0,
      count12: 0,
      count13: 0,
      count14: 0,
      count15: 0,
      count21: 0,
      count22: 0,
      count23: 0,
      count24: 0,
      count25: 0,
      count31: 0,
      count32: 0,
      count33: 0,
      count34: 0,
      count35: 0,
      count36: 0,
      count41: 0,
      count42: 0,
      count43: 0,
    };
  },
  methods: {
    goDetail(e) {
      switch (e.type) {
        case "DD":
          if (e.state == 0 || e.state == -1) {
            this.goto("/purchase/purchase_order_detail/" + e.id + "/2");
          } else {
            this.goto("/purchase/purchase_order_detail/" + e.id + "/3");
          }
          return;
        case "FH":
          this.goto("/purchase/invoice_detail/" + e.id + "/3");
          return;
        case "DZ":
          if (e.status == 1 || e.status == 5) {
            this.goto("/purchase/account_statement_edit/" + e.id + "/2");
          } else {
            this.goto("/purchase/account_statement_detail/" + e.id + "/3");
          }
          return;
        case "FP":
          this.goto("/purchase/purchase_invoice_detail/" + e.id + "/3");
          return;
        case "GYS":
          this.goto("/purchase/supply_detail/" + e.sys_supplier_code + "/3");
          return;
        default:
          return;
      }
    },
    async getListCount1() {
      this.loading = true;
      let res = await this.$api.purchase_demand.getList(this.list);
      this.loading = false;
      if (res) {
        this.count11 = res.count1 ? res.count1 : 0;
        this.count12 = res.count2 ? res.count2 : 0;
        this.count13 = res.count3 ? res.count3 : 0;
        this.count14 = res.count4 ? res.count4 : 0;
        this.count15 = res.count5 ? res.count5 : 0;
      }
    },
    async getListCount2() {
      this.loading = true;
      let res = await this.$api.order.getList(this.list);
      this.loading = false;
      if (res) {
        this.count21 = res.count1 ? res.count1 : 0;
        this.count22 = res.count2 ? res.count2 : 0;
        this.count23 = res.count3 ? res.count3 : 0;
        this.count24 = res.count4 ? res.count4 : 0;
        this.count25 = res.count6 ? res.count6 : 0;
      }
    },
    async getListCount3() {
      this.loading = true;
      let res = await this.$api.account_statement.getList(this.list);
      this.loading = false;
      if (res) {
        this.count31 = res.count1 ? res.count1 : 0;
        this.count32 = res.count2 ? res.count2 : 0;
        this.count33 = res.count3 ? res.count3 : 0;
        this.count34 = res.count4 ? res.count4 : 0;
        this.count35 = res.count5 ? res.count5 : 0;
        this.count36 = res.count6 ? res.count6 : 0;
      }
    },
    async getListCount4() {
      this.loading = true;
      let res = await this.$api.receipt.getList(this.list);
      this.loading = false;
      if (res) {
        this.count41 = res.count2 ? res.count2 : 0;
        this.count42 = res.count3 ? res.count3 : 0;
        this.count43 = res.count5 ? res.count5 : 0;
      }
    },
    async getList() {
      this.loading = true;
      let res = await this.$api.todo.getList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.getList();
    this.getListCount1();
    this.getListCount2();
    this.getListCount3();
    this.getListCount4();
  },
};
</script>
<style >
.iconfont1 {
  font-family: "iconfont" !important;
  font-size: 46px;
  font-style: normal;
  padding-left:20px;
  color: #ffffff !important;
}
</style>
